import { useEffect, useState } from "react";

/**
 * Returns `value` after it has stayed unchanged for `delay` ms.
 *
 * Use for debouncing search inputs so a request fires once the user pauses
 * typing, not on every keystroke:
 *
 *   const [input, setInput] = useState("");
 *   const query = useDebouncedValue(input.trim(), 350);
 *   // effect keyed on `query` runs the actual fetch
 */
export function useDebouncedValue(value, delay = 300) {
  const [debounced, setDebounced] = useState(value);

  useEffect(() => {
    const timer = setTimeout(() => setDebounced(value), delay);
    return () => clearTimeout(timer);
  }, [value, delay]);

  return debounced;
}

export default useDebouncedValue;
